import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];
import { NewsArticleViewAllComponent } from "./news-article-view-all.component";
routes.push({ path: 'news-articles', component: NewsArticleViewAllComponent});

export const NewsArticleRoutingProvider = RouterModule.forRoot(routes, { useHash: true });